export default "<p>sidenav-tree works!</p>\n"